import CustomLoading from "../../../utils/LoadingIndicator/CustomLoading";
import useAdminDashboard from "./useAdminDashboard";

const UsersComponent = () => {
  const { users, isLoading, errors } = useAdminDashboard();
  if (isLoading.users) {
    return <CustomLoading />;
  }
  if (errors.users) {
    return (
      <p className="text-xl text-red-700 font-semibold">Some Error Occured</p>
    );
  }
  const formatCurrency = (amount) => {
    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "EGP",
    }).format(amount);
  };

  const userStats = [
    {
      label: "Total Users",
      value: users?.totalUsers || 0,
      color: "text-blue-600",
    },
    {
      label: "New Users",
      value: users?.newUsers || 0,
      color: "text-green-600",
    },
    {
      label: "Active Users",
      value: users?.activeUsers || 0,
      color: "text-purple-600",
    },
    {
      label: "Verified Users",
      value: users?.verifiedUsers || 0,
      color: "text-indigo-600",
    },
  ];

  return (
    <div className="p-4 bg-white rounded-lg shadow-sm border border-gray-100">
      <h2 className="text-xl font-bold text-gray-800 mb-4">User Analytics</h2>

      {/* User Stats */}
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-2 mb-4">
        {userStats.map((stat, index) => (
          <div key={index} className="text-center p-3 bg-gray-50 rounded-md">
            <p className={`text-lg font-semibold ${stat.color}`}>
              {stat.value}
            </p>
            <p className="text-xs text-gray-600">{stat.label}</p>
          </div>
        ))}
      </div>

      {/* Top Users */}
      <div>
        <h3 className="text-base font-semibold text-gray-800 mb-2 flex items-center">
          {/* <Star className="w-5 h-5 mr-2 text-yellow-500" /> */}
          Top Users
        </h3>
        <div className="space-y-2">
          {users?.topUsers?.map((user, index) => (
            <div
              key={user.userId}
              className="flex items-center justify-between p-3 bg-gray-50 rounded-md hover:bg-gray-100 transition-colors"
            >
              <div className="flex items-center space-x-2">
                <div className="w-8 h-8 bg-gradient-to-br from-blue-500 to-purple-600 rounded-full flex items-center justify-center text-white font-bold text-sm">
                  {user.name?.charAt(0) || "U"}
                </div>
                <div>
                  <p className="font-semibold text-gray-800 text-sm">
                    {user.name || "Unknown User"}
                  </p>
                  <p className="text-xs text-gray-500">{user.email}</p>
                </div>
              </div>
              <div className="text-right">
                <p className="font-semibold text-green-600 text-sm">
                  {formatCurrency(user.totalSpent)}
                </p>
                <p className="text-xs text-gray-500">{user.orders} orders</p>
              </div>
            </div>
          )) || <p className="text-gray-500 text-sm">No user data available</p>}
        </div>
      </div>
    </div>
  );
};

export default UsersComponent;
